import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DataImportErrorResult {
  errors: any[];
}

@Component({
  selector: 'app-data-import-error-modal',
  templateUrl: './data-import-error-modal.component.html',
  styleUrls: ['./data-import-error-modal.component.scss'],
  standalone: false
})
export class DataImportErrorModalComponent {
  constructor(
    public dialogRef: MatDialogRef<DataImportErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataImportErrorResult
  ) {}

  format(str: string) {
    if (!str?.endsWith('.')) {
      return str + '.';
    }
    return str;
  }
}
